module.exports = __webpack_public_path__ + "img/jumbotron-pic@2x.45df06bc.png";